import React from "react";
import TextField from "@material-ui/core/TextField";

export default function Inputs(props) {
  return (
    <form className="form" noValidate autoComplete="off">
      <div>
        <TextField
          disabled
          id="filled-disabled"
          label={props.data.key}
          defaultValue={props.data.value}
          variant="filled"
        />
      </div>
      <div>
        <TextField
          onBlur={(value) => {
            props.onChange({ key: props.data.key, value: value.target.value });
          }}
          required
          id="filled-required"
          variant="filled"
        />
      </div>
    </form>
  );
}
